module.exports = "/images/home-button.svg?4e2402a5d274232e9b2e2855c67a37a7";